import React from 'react'

const React_Coding_Practice_40 = () => {
  return (
    <div>
      <h1>Coding Pratice 40</h1>
    </div>
  )
}

export default React_Coding_Practice_40
